<template>
  <v-row class="page-breadcrumb">
    <v-col cols="12" sm="12" class="pa-0">
      <div class="px-2">
        <v-toolbar dense flat class="transparent pa-0" height="40px">
          <v-toolbar-title class="pt-3">
            <span class="text--primary">{{ title }}</span>
          </v-toolbar-title>
          <v-toolbar-title
            class="toobar-extension transparent pb-3"
            slot="extension"
          >
            <v-breadcrumbs :items="getBreadcrumbs" class="pa-0">
              <template v-slot:divider v-if="breadcrumbs">
                <v-icon>{{ $store.state.locale === 'en' ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
              </template>
            </v-breadcrumbs>

            <slot></slot>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "BaseBreadcrumb",
  computed: {
    getBreadcrumbs() {
      return [...this.dashboard, ...this.breadcrumbs ]
    }
  },
  props: {
    title: String,
    breadcrumbs: Array,
    icon: String,
  },
  data() {
    return {
      dashboard: [{
        text: this.$t('title.dashboard'),
        disabled: false,
        to: "/",
      }]
    }
  }
};
</script>
<style lang="scss">
.page-breadcrumb {
  margin: -24px -25px 27px -25px;
}
</style>